import axios from "axios";

const axiosInstance = axios.create({
  //baseURL: "https://teach-backend.bigbooster.in/",
  baseURL: `${process.env.REACT_APP_API_URL}/`,
});

export default axiosInstance;
